import React, { Component, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router, { isTopLevelRoute, getCurrentRoute } from 'sites/routes/router';
import { push } from 'connected-react-router';
import { closePromotionNotification, collapseMenu, openClosePenndingPaymentModal, setShareModalAction, setShowNSFWModalAction, updateSiteInfoAction } from 'sites/state/modules/common/actions';
import { currentLocationPathSelector } from 'sites/state/modules/router/selectors';
import {
   showNavigationListSelector,
   unreadMessageCount,
   chatPanelSelector,
   publicMessagesSelector,
   groupChatSelector,
   hiddeChatIconSelector,
   settingsSelector as chatSettingsSelector,
   privateMessagesSelector,
   privateChatSelector,
} from 'sites/state/modules/chat/selectors';
import {
   tipModalDataSelector,
   isCheckLimitFetchingSelector,
} from 'sites/state/modules/tip/selectors';
import {
   setModalState as setTipModalState,
} from 'sites/state/modules/tip/actions';
import { setSendModalState } from 'sites/state/modules/purchase-send/actions';
import { onClickChat,  setChatPanelAction, setActiveTab } from 'sites/state/modules/chat/actions';
import { chatInitOperation, fetchMessagesOperation } from 'sites/state/modules/chat/operations';
import { initedSelector } from 'sites/state/modules/chat/selectors';
import { fetchLiveStreamMessagesOperation } from 'sites/state/modules/livestream/operations';
import PageHeader from 'common/components/modules/page-header';
import {
   authUserSelector,
   siteInfoSelector,
   screenWidthSelector,
   onlineStreamSelector,
   promotionNotificationSelector,
   isOpenPenndingPaymentModalSelector,
   isAgeVerificationRequiredSelector,
   shareModalSelector,
   isGlobalLoadingSelector,
} from 'sites/state/modules/common/selectors';
import { history, isPreviousLocationWithinApp } from 'sites/state/store';
// import { isFriskybussiness } from 'sites/utils/Helpers';
// import friskybussinessLogo from 'assets/images/Logo.png';
// import ChatNotificationContainer from 'sites/containers/modules/chat/notification';
// import TipMeContainer from 'sites/containers/pages/tip';
// import { getUserStatusType } from 'sites/utils/utils.js';
import QueryParams from 'sites/utils/QueryParams';
import { getWalletBalanceOperation } from 'sites/state/modules/common/operations';
import { isGuestRoute } from 'sites/utils/utils';
import PromotionNotification from "sites/views/promotion-notification";
import { createPortal } from 'react-dom';
// import NotificationsContainer from '../notifications';

import {
   unseenNotificationsCountSelector,
   notificationsPanelSelector,
} from 'sites/state/modules/notifications/selectors';
import {
   setNotificationsPanelAction,
} from 'sites/state/modules/notifications/actions.js';
import {
   markAllAsSeenNotificationsOperations,
   fetchNotificationsOperation,
} from 'sites/state/modules/notifications/operations';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import Button from 'common/components/elements/buttons/primary';
// import intercomMoreInfo, { CONTACT_SUPPORT } from 'sites/utils/IntercomMoreInfo';
import { generateUriSegment } from 'common/utils/mediaRouteHelper';
import { getPurchaseMethods } from 'sites/api/AuthApi';
import { isOpenSendModalSelector, modalTypeSelector, pageTypeSelector } from 'sites/state/modules/purchase-send/selectors';
// import SendModal from 'sites/containers/pages/purchase-send';
import { pollDataSelector } from 'sites/state/modules/polls/selectors';
import { openActivePollModalOperation } from 'sites/state/modules/polls/operations';
// import ShareModal from 'common/components/modules/share-popup';
import { getSiteLink } from 'common/utils/helper';
import { activeOrderRequestSelector } from 'sites/state/modules/store/selectors';
import toast from 'common/utils/toast';
import { fetchOrderRequestById } from 'sites/state/modules/store/operations';
import { boomfiModalSelector } from 'sites/state/modules/purchase/selectors';
import BoomfiPaymentModal from 'common/components/modules/boomfi-payment-modal';
import { getHomepageSiteHeaderSettings } from './modules/helpers'
import { siteHeaderSelector } from 'sites/state/modules/homepage/selectors';

const ChatNotificationContainer = lazy(() => import('sites/containers/modules/chat/notification'));
const NotificationsContainer = lazy(() => import('sites/containers/modules/notifications'));
const TipMeContainer = lazy(() => import('sites/containers/pages/tip'));
const SendModal = lazy(() => import('sites/containers/pages/purchase-send'));
const ShareModal = lazy(() => import('common/components/modules/share-popup'));


class PageHeaderContainer extends Component {

   static propTypes = {
      locationPath: PropTypes.string.isRequired,
      goTo: PropTypes.func.isRequired,
      collapseMenu: PropTypes.func.isRequired,
      user: PropTypes.object,
      siteHeader: PropTypes.object,
      showNavigationList: PropTypes.bool,
      onClickChat: PropTypes.func,
      chatUnReadMessageCount: PropTypes.number,
      // screenWidth: PropTypes.number,
      siteInfo: PropTypes.object,
      screenWidth: PropTypes.number,
      unreadChatMessageCount: PropTypes.any,
      initedChat: PropTypes.bool,

      chatPanel: PropTypes.object,
      publicMessages: PropTypes.object,
      groupChat: PropTypes.object,
      fetchMessages: PropTypes.func,
      setChatPanel: PropTypes.func,
      checkTipLimit: PropTypes.func,
      setTipModalState: PropTypes.func,
      tipModalData: PropTypes.object,
      isCheckLimitFetching: PropTypes.bool,
      setSendModalState: PropTypes.func,
      getWalletBalance: PropTypes.func,
      dkMenuIconColor: PropTypes.string,
      onlineStream: PropTypes.bool,
      hiddeChatIcon: PropTypes.bool,
      setActiveTab: PropTypes.func,
      fetchLiveStreamMessages: PropTypes.func,
      chatInitOperation: PropTypes.func,
      chatSettings: PropTypes.object,
      privateMessages: PropTypes.object,
      privateChat: PropTypes.object,
      closePromotionNotification: PropTypes.func,
      promotionNotification: PropTypes.bool,

      unseenNotificationsCount: PropTypes.object,
      notificationsPanel: PropTypes.object,
      setNotificationsPanel: PropTypes.func,
      markAllAsSeenNotifications: PropTypes.func,
      fetchNotifications: PropTypes.func,
      openClosePenndingPaymentModal: PropTypes.func,
      isOpenPenndingPaymentModal: PropTypes.bool,
      isOpenSendModal: PropTypes.bool,
      modalType: PropTypes.string,
      pageType: PropTypes.string,
      pollData: PropTypes.object,
      openPollModal: PropTypes.func,
      isAgeVerificationRequired: PropTypes.bool,
      setShowNSFWModal: PropTypes.func,
      shareModal: PropTypes.object,
      setShareModal: PropTypes.func,
      updateSiteInfo: PropTypes.func,
      activeOrderRequest: PropTypes.object,
      fetchOrderRequestById: PropTypes.func,
      boomfiModal: PropTypes.object,
      isGlobalLoading: PropTypes.bool,
   };


   chatRef = React.createRef();
   notificationRef = React.createRef();

   state = {
      open: false,
      headerIsTransparent: false,
      intercomUnreadCount: 0,
      isLoadingTryPaymentButton: false,
   }
   Timeout = null


   componentDidMount(){
      const { setSendModalState } = this.props
      const params = QueryParams.getParsedSearchParams();
      if(params && params['open-top-up'] === 'true') {
         if(params['modal-key'] === 'top-up'){
            setSendModalState({ modalKey: 'top_up' });
         }
         this.tipAction(true, 'top_up');
      }
      document.addEventListener('mousedown', this.handleClickOutside);


      if(window?.Intercom){
         window.Intercom('onUnreadCountChange', (unreadCount) => {
            const intercomUnreadCount = unreadCount > 99 ? '99+' : unreadCount;
            this.setState({ intercomUnreadCount })
         });
      }

      if(QueryParams.getParam('share')){
         QueryParams.removeQueryParam('share')
      }

      this.socket = window.memberOrderRequestsSocket
   }

   componentDidUpdate(prevProps, prevState) {
      const { locationPath, siteHeader, screenWidth, siteInfo } = this.props

      // Homepage settings
      if(Router.route('HOMEPAGE').match(locationPath)) {
         if(siteHeader !== prevProps.siteHeader) {
            const {
               hasSiteHeader,
            } = getHomepageSiteHeaderSettings(siteHeader, screenWidth <= 1024, siteInfo.is_dark_bg)
            this.setState({ headerIsTransparent: hasSiteHeader })
            if(hasSiteHeader) {
               window.addEventListener('scroll', this.handleScroll);
            }
         }
      } else {
         window.removeEventListener('scroll', this.handleScroll);
      }

   }

   handleClickOutside = (event) => {
      const {
         screenWidth,
         onClickChat,
         showNavigationList,
      } = this.props;
      if(screenWidth > 1024) {
         if(this.chatRef && this.chatRef.current && !this.chatRef.current.contains(event.target)) {
            if(showNavigationList) {
               const tooltip = document.querySelector('#site-chat-notification')
               if(!tooltip?.contains(event.target)){
                  onClickChat(!showNavigationList)
               }
            }
         }
      }
   }

   componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      clearTimeout(this.Timeout)
      this.chatRef = null
      document.removeEventListener('mousedown', this.handleClickOutside);
   }

   handleScroll  = () => {
      const { headerIsTransparent } = this.state
      const { scrollTop } = document.documentElement;
      if(scrollTop < 100 && !headerIsTransparent) {
         this.setState({ headerIsTransparent: true })
      }
      if(scrollTop > 100 && headerIsTransparent){
         this.setState({ headerIsTransparent: false })
      }
   }


   collapseMenu = () => {
      const { collapseMenu } = this.props;
      collapseMenu();
   }

   getSignInLink = () => {
      const {  locationPath } = this.props;

      if(!locationPath) return Router.route('SIGN_IN').getCompiledPath()
      let goBack = null
      if(!isGuestRoute(locationPath)) {
         goBack = `go-back=${ locationPath }`;
         if(!!window.location.search) {
            const search = encodeURIComponent(window.location.search)
            goBack = `${ goBack }${ search }`
         }
      } else {
         goBack = window.location.search
      }

      return `${ Router.route('SIGN_IN').getCompiledPath() }?${ goBack }`
   }
   goToJoin = () => {
      const { goTo } = this.props;

      goTo(Router.route('JOIN').getCompiledPath())
   }

   isGuest = () => {
      const { locationPath, user } = this.props;
      return user === null && !Router.route('SIGN_IN').match(locationPath);
   }
   isPublicMember = () => {
      const { user } = this.props;
      return !user?.subscriber
   }
   tipAction = (bool = true) => {
      const { getWalletBalance, setTipModalState, isCheckLimitFetching, setSendModalState } = this.props;
      if(!isCheckLimitFetching) {
         if(bool){
            getWalletBalance();
            setSendModalState({ modalKey: 'tip', modalType: 'tip' });
            setTipModalState({ isTipModal: true, isInitTip: true, isLimitModal: false })
         } else {
            setTipModalState({ isTipModal: false });
         }
      }
   }

   isShowPromotionNotification = () => {
      const { siteInfo, promotionNotification, locationPath, user, isGlobalLoading } = this.props
      return (Boolean(siteInfo.public_promotion) && promotionNotification
      && !Router.route('JOIN').match(locationPath) && !Router.route('PURCHASE_MEMBERSHIP').match(locationPath)
      && (!user || (user.membership_status !== 'active' && user.membership_status !== 'free' && user.membership_status !== 'cancelled')))
      && !isGlobalLoading
   }

   hasAvailablePricings = () => {
      const { siteInfo } = this.props
      return siteInfo?.suggested_membership_plan_period !== 0
   }

   getChatModal = () => {
      const {
         showNavigationList,
         onClickChat,
         unreadChatMessageCount,
         user,
         initedChat,
         setChatPanel,
         screenWidth,
         chatPanel,
         publicMessages,
         groupChat,
         fetchMessages,
         onlineStream,
         // siteInfo: {
         //    chat_settings: chatSettings,
         // },
         hiddeChatIcon,
         setActiveTab,
         locationPath,
         fetchLiveStreamMessages,
      } = this.props;

      if((onlineStream && Router.route('LIVE_STREAM_STUDIO').match(locationPath) && screenWidth < 1025) || hiddeChatIcon) {
         return
      }
      let hiddeIcon = hiddeChatIcon;
      const isLivestreamChat = onlineStream && Router.route('LIVE_STREAM_STUDIO').match(locationPath) && user;
      if(hiddeIcon){
         hiddeIcon = false
      }
      const chat = {
         show: true,
         hiddeChatIcon: hiddeChatIcon && !isLivestreamChat,
         count: unreadChatMessageCount,
         hasIntercomClass: true,
         ref: this.chatRef,
         id: 'site-chat-notification',
         onClickChat: () => {
            if(isLivestreamChat){
               let bool = !chatPanel.isOpen
               let data = {
                  isMobile: screenWidth < 1025,
                  isOpen: bool,
               }
               if(bool){
                  data = {
                     ...data,
                     closeChatMessages: bool,
                  }
               }
               if(!bool) {
                  setChatPanel({ data })
                  this.Timeout = setTimeout(() => {
                     setChatPanel({ ...data, closeChatMessages: bool })
                  }, 600)
               } else {
                  setChatPanel({ ...data, closeChatMessages: bool })

               }
               setActiveTab({
                  type: 'livestream',
                  id: 'live_stream',
                  conversation: {
                     conversation_name: 'Livestream chat',
                     avatars: null,
                  },
               })
               if(!chatPanel.isOpen){
                  fetchLiveStreamMessages();
                  onClickChat(!showNavigationList, false)
               }
               return
            }

            if(!user) {
               let bool = !chatPanel.isOpen
               let data = {
                  isMobile: screenWidth < 1025,
                  isOpen: bool,
               }
               if(bool){
                  data = {
                     ...data,
                     closeChatMessages: bool,
                  }
               }
               setChatPanel(data)
               if(!bool) {
                  this.Timeout = setTimeout(() => {
                     setChatPanel({ closeChatMessages: bool })
                  }, 600)
               }
            } else {
               const { chatSettings, privateMessages, chatInitOperation, privateChat } = this.props;
               if(!showNavigationList){
                  chatInitOperation(!initedChat)

                  if(chatSettings.is_group_chat_active && chatSettings.chat_private_is_active){
                     onClickChat(!showNavigationList)
                  } else {

                     onClickChat(false)
                     if(chatSettings.is_group_chat_active && !chatSettings.chat_private_is_active){
                        if(groupChat.chat_room_id) {
                           fetchMessages(groupChat.chat_room_id, { ...groupChat, type: 'public' }, publicMessages.inted)
                        }
                     }
                     if(!chatSettings.is_group_chat_active && chatSettings.chat_private_is_active){
                        if(privateChat.chat_room_id) {
                           fetchMessages(privateChat.chat_room_id, { ...privateChat, type: 'private' }, privateMessages.inted)
                        }
                     }

                     let bool = !chatPanel.isOpen
                     let data = {
                        isMobile: screenWidth < 1025,
                        isOpen: bool,
                     }
                     if(bool){
                        data = {
                           ...data,
                           closeChatMessages: bool,
                        }
                     }
                     setChatPanel(data)
                     if(!bool) {
                        this.Timeout = setTimeout(() => {
                           setChatPanel({ closeChatMessages: bool })
                        }, 600)
                     }
                  }
               } else {
                  onClickChat(!showNavigationList)

               }
            }
         },
         component: (
            <Suspense fallback={ <></> }>
               <ChatNotificationContainer />
            </Suspense>
         ),
         showNavigationList: showNavigationList,
      }
      return chat
   }

   getNotificationsList = () => {
      const {
         user,
         unseenNotificationsCount,
         markAllAsSeenNotifications,
         setNotificationsPanel,
         fetchNotifications,
         notificationsPanel: {
            isOpen,
         },
      } = this.props
      if(!user) {
         return null
      }
      const notifications = {
         show: true,
         component: (
            <Suspense fallback={ <></> }>
               <NotificationsContainer />
            </Suspense>
         ),
         count: unseenNotificationsCount?.badgeCount,
         ref: this.notificationRef,
         onClick: async () => {
            if(unseenNotificationsCount?.count > 0) {
               await markAllAsSeenNotifications();
            }
            setNotificationsPanel({ isOpen: !isOpen, withAnimation: true });
            if(!isOpen) {
               await fetchNotifications();
            }
         },
      }
      return notifications;
   }

   getPollsState = () => {
      const { openPollModal, pollData, user } = this.props

      if(!Boolean(pollData) || !Boolean(user)) return null;

      return {
         show: true,
         clickAction: openPollModal,
         memberViewed: pollData.member_viewed,
      }
   }

   getIsSiteLogoLockedForSFW = () => {
      const { isAgeVerificationRequired, siteInfo } = this.props
      if(!isAgeVerificationRequired || siteInfo.main_logo_mode !== 'image-logo') {
         return false
      }

      return !siteInfo.site_logo_sfw
   }

   getHomepageHeader = () => {
      const {
         siteInfo,
         screenWidth,
         user,
         closePromotionNotification,
         goTo,
         locationPath,
         isAgeVerificationRequired,
         setShowNSFWModal,
         siteHeader,
      } = this.props
      const { headerIsTransparent, intercomUnreadCount } = this.state
      let siteName = ''
      if(siteInfo && siteInfo.site_long_name) {
         siteName = siteInfo.site_long_name.charAt(0).toUpperCase() + siteInfo.site_long_name.slice(1);
      }
      let props = { siteLogo: siteInfo.site_logo }
      if(!siteInfo.site_logo) {
         props = {
            title: siteName,
         }
      }
      const {
         iconColorOverSiteHeader,
         dkMenuIconColor,
      } = getHomepageSiteHeaderSettings(siteHeader, screenWidth <= 1024, siteInfo.is_dark_bg)

      let menuColor = dkMenuIconColor || 'major'
      if(!headerIsTransparent) menuColor = 'major'
      const chat = this.getChatModal()
      return (
         <>

            <PageHeader
               { ...props }
               fontIconSize='doubleLarge'
               fontIconColor={ headerIsTransparent ? iconColorOverSiteHeader : 'major' }
               leftIconName='menu'
               leftIconAction={ this.collapseMenu }
               // guestAction={ this.goToSignInPage }
               goToJoin={ this.goToJoin }
               guest={ this.isGuest() }
               isPublicMember={ this.isPublicMember() }
               chat={ chat }
               isWhite={ screenWidth < 1025 ? !!headerIsTransparent : false }
               menuIconColor={ screenWidth < 1025 ? null : menuColor }
               tipAction={ this.tipAction }
               user={ user }
               isMobile={ screenWidth < 1025 }
               transparentHeader={ headerIsTransparent }
               notifications={ this.getNotificationsList() }
               hasAvailablePricings={ this.hasAvailablePricings() }
               locationPath={ locationPath }
               signInLink={ this.getSignInLink() }
               memberSupportUnreadCount={ intercomUnreadCount }
               memberPoll={ this.getPollsState() }
               isSiteLogoBluredForSfw={ this.getIsSiteLogoLockedForSFW() }
               isAgeVerificationRequired={ isAgeVerificationRequired }
               onClickVerifyButton={ () => setShowNSFWModal(true) }
            >
               {
                  this.isShowPromotionNotification() && (
                     <>
                        {
                           createPortal(
                              <PromotionNotification
                                 promotion={ siteInfo.public_promotion }
                                 onClose={ closePromotionNotification }
                                 onClickGetThisDeal={ () => goTo(Router.route('JOIN').getCompiledPath()) }
                                 screenWidth={ screenWidth }
                              />,
                              document.getElementById('promo')
                           )
                        }

                     </>
                  )
               }
            </PageHeader>
         </>
      );
   }

   getTopLevelRoutesHeader = () => {
      const {  goTo, siteInfo, user, screenWidth, locationPath, closePromotionNotification, isAgeVerificationRequired, setShowNSFWModal } = this.props;
      const { intercomUnreadCount } = this.state
      let title = null;
      const currentRoute = getCurrentRoute(locationPath);
      if(currentRoute) {
         title = currentRoute.getTitle();
      }
      let siteName = ''
      if(siteInfo && siteInfo.site_long_name) {
         siteName = siteInfo.site_long_name.charAt(0).toUpperCase() + siteInfo.site_long_name.slice(1);
      }
      let props = { siteLogo: siteInfo.site_logo }
      if(!siteInfo.site_logo) {
         props = {
            title: title || siteName,
         }
      }
      const chat = this.getChatModal()
      return (
         <PageHeader
            { ...props }
            user={ user }
            fontIconSize='doubleLarge'
            fontIconColor='major'
            leftIconName='menu'
            leftIconAction={ this.collapseMenu }
            // guestAction={ this.goToSignInPage }
            guest={ this.isGuest() }
            isPublicMember={ this.isPublicMember() }
            goToJoin={ this.goToJoin }
            chat={ chat }
            tipAction={ this.tipAction }
            // goToHomePage={ () => goTo(Router.route('HOMEPAGE').getCompiledPath())  }
            isMobile={ screenWidth < 701 }
            notifications={ this.getNotificationsList() }
            hasAvailablePricings={ this.hasAvailablePricings() }
            locationPath={ locationPath }
            signInLink={ this.getSignInLink() }
            memberSupportUnreadCount={ intercomUnreadCount }
            memberPoll={ this.getPollsState() }
            isSiteLogoBluredForSfw={ this.getIsSiteLogoLockedForSFW() }
            isAgeVerificationRequired={ isAgeVerificationRequired }
            onClickVerifyButton={ () => setShowNSFWModal(true) }
         >
            {
               this.isShowPromotionNotification() && (
                  <>
                     {
                        createPortal(
                           <PromotionNotification
                              promotion={ siteInfo.public_promotion }
                              onClose={ closePromotionNotification }
                              onClickGetThisDeal={ () => goTo(Router.route('JOIN').getCompiledPath()) }
                              screenWidth={ screenWidth }
                           />,
                           document.getElementById('promo')
                        )
                     }

                  </>
               )
            }
         </PageHeader>
      );
   }

   getChildLevelRoutesHeader = () => {
      const { locationPath, goTo, screenWidth, user, siteInfo, closePromotionNotification, isAgeVerificationRequired, setShowNSFWModal } = this.props;
      const { intercomUnreadCount } = this.state
      const params = getCurrentRoute(locationPath).match(locationPath).params;
      let title = null;
      const currentRoute = getCurrentRoute(locationPath);
      if(currentRoute) {
         title = currentRoute.getTitle();
      }
      const cancel = currentRoute.getCancel();

      let parents = this.getParents(currentRoute, []);
      const chat = this.getChatModal()
      const headerProps = {
         title: title,
         user: user,
         fontIconSize: 'doubleLarge',
         fontIconColor: 'major',
         onClickMyAccount: () => goTo(Router.route('MY_ACCOUNT').getCompiledPath()),
         // guestAction: this.goToSignInPage,
         tipAction: this.tipAction,
         guest: this.isGuest(),
         goToJoin: () => this.goToJoin(),
         chat: chat,
         isMobile: screenWidth <= 700,
         isPublicMember: this.isPublicMember(),
         notifications: this.getNotificationsList(),
         hasAvailablePricings: this.hasAvailablePricings(),
         locationPath: locationPath,
         signInLink: this.getSignInLink(),
         memberSupportUnreadCount: intercomUnreadCount,
         memberPoll: this.getPollsState(),
         isSiteLogoBluredForSfw: this.getIsSiteLogoLockedForSFW(),
         isAgeVerificationRequired: isAgeVerificationRequired,
         onClickVerifyButton: () => setShowNSFWModal(true),
      };
      if(screenWidth <= 700) {
         headerProps['leftIconName'] = cancel ? 'close' : 'arrow-left';
         headerProps['leftIconAction'] = cancel ? () => { goTo(Router.route('HOMEPAGE').getCompiledPath()) } : () => this.goBack(params);
      } else {
         headerProps['parents'] = parents;
         headerProps['leftIconName'] = 'menu';
         headerProps['leftIconAction'] = this.collapseMenu;
      }
      return (
         <PageHeader
            { ...headerProps }
         >
            {
               this.isShowPromotionNotification() && (
                  <>
                     {
                        createPortal(
                           <PromotionNotification
                              promotion={ siteInfo.public_promotion }
                              onClose={ closePromotionNotification }
                              onClickGetThisDeal={ () => goTo(Router.route('JOIN').getCompiledPath()) }
                              screenWidth={ screenWidth }
                           />,
                           document.getElementById('promo')
                        )
                     }

                  </>
               )
            }
         </PageHeader>
      );
   }

   getParents = (parent, parents) => {
      if(parent.getParent()) {
         let title = parent.getParent().title;
         let titleSuffix = '';
         if(parent.parentKey !== 'SIGN_IN') {
            if(parent.parentKey === 'PHOTOSETS') {
               title = 'Photosets'
            }
            if(parent.parentKey === 'VIDEOS') {
               title = 'Videos'
            }
            if(parent.parentKey === 'STORE') {
               title = 'Store'
            }
            const backSearchParams = parent.getBackSearchParams()
            const backSearchParamsTitle = parent.getBackSearchParamsTitle();
            let parentLink = Router.route(`${ parent.parentKey }`).getCompiledPath();
            if(parent.getParent()?.hasBackSearchParams){
               if(backSearchParams){
                  parentLink = `${ parentLink }?${ backSearchParams }`;
               }
               if(backSearchParamsTitle){
                  titleSuffix = `: ${ backSearchParamsTitle }`;
               }
            }
            parents.unshift({
               parentKey: parent.parentKey,
               title: title + titleSuffix,
               link: parentLink,
            })
         }
      }
      if(!parent.topLevel) {
         this.getParents(parent.getParent(), parents);
      }
      return parents;
   }

   goBack = (params) => {
      const {
         locationPath,
         goTo,
      } = this.props
      if(!isPreviousLocationWithinApp()) {
         return goTo(getCurrentRoute(locationPath).getParent().getCompiledPath(params))
      } else {
         return history.goBack()
      }
   }

   onClickOpenPurchaseModal = async () => {
      const {
         user: {
            pending_payment_data,
         },
         openClosePenndingPaymentModal,
         setSendModalState,
      } = this.props
      const {
         payload: { id, note, price, option, extras, shipping_fee_detail_id, count, questions, is_order_request, shippingValue, total_price, duration, is_custom_form, purchase_type },
         product,
         id: orderId,
      } = pending_payment_data?.[0]
      const { product_type, name } = product

      this.setState({ isLoadingTryPaymentButton: true })

      try {
         let query = purchase_type === 'wallet' ? 'only_wallet=true' : ''
         if(total_price) query += `amount=${ total_price }`

         const { data } = await getPurchaseMethods('products', id, query)

         let purchasePayload = {
            name, id, note, price, option, extras,
            total: total_price,
            item: option?.price,
            order_request_payment_id: +orderId,
            is_custom_form,
            storeData: {
               ...product,
               number_in_stock_left: Math.max(0, (product?.number_in_stock_left || 0) - 1),
            },
         }

         if(product_type === 'physical_item'){
            purchasePayload = {
               ...purchasePayload,
               count,
               shipping_fee_detail_id,
               shipping: shippingValue,
               item: count * option?.price,
            }
         } else {
            if(product_type === 'priced_by_the_minute') {
               purchasePayload = {
                  ...purchasePayload,
                  duration,
                  item: +option?.price * duration,
               }
            }
         }

         let item = purchasePayload?.item

         if(typeof item === 'number' && !Number.isInteger(item)) {
            console.log('item', item);
            item = item.toFixed(2)
         }

         purchasePayload = { ...purchasePayload, option, extras, questions, is_order_request, isRetryPayment: true, item: `${ item } USD` }

         console.log(purchasePayload);

         const { storeData: _, ...purchaseParams } = purchasePayload
         let param = `&params=${ encodeURIComponent(JSON.stringify(purchaseParams)) }`


         await setSendModalState({
            isOpenSendModal: true,
            isOpenChoosePaymentModal: true,
            modalType: 'store',
            methods: data,
            purchaseData: { param, ...purchasePayload },
            pageType: 'all',
         })
         await openClosePenndingPaymentModal(false)
      } catch (error) {

      } finally {
         this.setState({ isLoadingTryPaymentButton: false })
      }
   }

   actionAfterPayment = (data) => {
      const { purchaseData, finalRespons } = data
      const { activeOrderRequest, fetchOrderRequestById } = this.props

      console.log({ activeOrderRequest, data, socket: this.socket }, 'line 838');
      if(!!purchaseData?.order_request_payment_id) {
         if(!!this.socket) {
            this.socket.emit('order_request_member:update', { order_request_payment_id: purchaseData?.order_request_payment_id }, (data) => {
               if(data.error) {
                  toast.error('Something went wrong')
               }
            })
         }

         if((!!finalRespons?.success || finalRespons?.status === 'success') && activeOrderRequest?.order_details?.id === purchaseData?.order_request_payment_id) {
            fetchOrderRequestById(activeOrderRequest?.order_details?.id)
         }

      }
   }

   render() {
      const {
         screenWidth,
         user,
         isOpenPenndingPaymentModal,
         siteInfo,
         goTo,
         isOpenSendModal,
         modalType,
         openClosePenndingPaymentModal,
         setSendModalState,
         pageType,
         shareModal,
         setShareModal,
         boomfiModal,
      } = this.props
      const { locationPath, tipModalData, chatPanel } = this.props;
      const { isLoadingTryPaymentButton } = this.state
      let header = null
      let isOnePenndingPayment = user?.pending_payment_data?.length === 1

      if(Router.route('HOMEPAGE').match(locationPath)){
         header = this.getHomepageHeader();
      } else if(isTopLevelRoute(locationPath)) {
         header = this.getTopLevelRoutesHeader();
      } else {
         header = this.getChildLevelRoutesHeader();
      }

      const hidePopup = !(
         Router.route('PAYMENT_APPROVED').match(this.props.locationPath) ||
         Router.route('PAYMENT_DECLINED').match(this.props.locationPath) ||
         Router.route('PURCHASE_STORE').match(this.props.locationPath)
      );

      return <>
         {
            (tipModalData.isTipModal || tipModalData.isLimitModal) && (!chatPanel.isOpen || screenWidth < 1024) && (
               <Suspense fallback={ <></> }>
                  <TipMeContainer
                     tipModalData={ tipModalData }
                     tipAction={ this.tipAction }
                  />
               </Suspense>
            )
         }
         {
            isOpenPenndingPaymentModal && hidePopup &&
            <ConfirmModal
               type='action'
               iconSize='2xl'
               buttonClassName='mt-3'
               withoutCloseButton={ false }
               contentWidth='375px'
               isPreventDeafault={ false }
               isMobile={ screenWidth < 700 }
               title={ `Payment${ isOnePenndingPayment ? '' : 's' } declined` }
               withoutCancelButton={ false }
               nonPrimaryColor
               icon={ 'cancel' }
               iconColor={ 'error' }
               secondButtonTitle={ !isOnePenndingPayment ? 'Contact support' : 'Review my order' }
               textColor={ 'secondary' }
               closeBtnClassName='w-full !m-0 p-[18px] pb-0 h-8 [&>button]:!justify-end'
               buttonText={ !isOnePenndingPayment ? 'Review my orders' : 'Try payment again now' }
               secondButtonAction={ () => {
                  if(!isOnePenndingPayment) {
                     if(window?.Intercom) {
                        window.Intercom('show');
                     }
                  } else {
                     goTo(Router.route('ORDER_DETAILS').getCompiledPath({ id: generateUriSegment(user?.pending_payment_data?.[0]?.id, user?.pending_payment_data?.[0]?.product?.name) }))
                     openClosePenndingPaymentModal(false)
                  }
               } }
               action={ () => {
                  if(!isOnePenndingPayment) {
                     goTo(Router.route('MY_ORDERS').getCompiledPath())
                     openClosePenndingPaymentModal(false)
                  } else {
                     this.onClickOpenPurchaseModal()
                  }
               } }
               onCloseModal={ () => {
                  openClosePenndingPaymentModal(false)
                  setSendModalState({ isOpenSendModal: false, isSend: false, isNotEnoughtBalance: false, modalKey: 'tip', pageType: '' })
               } }
               secondButtonClassName={ isOnePenndingPayment ? 'mt-3' : 'mt-8' }
               secondButtonPosition={ !isOnePenndingPayment ? 'top' : 'bottom' }
               isLoading={ isLoadingTryPaymentButton }
            >
               <div class='w-full flex flex-col justify-center items-center gap-4 text-secondary dark:text-secondary-dark text-center'>
                  <p>{ siteInfo?.admin_screen_name } tried to accept your { isOnePenndingPayment ? `${ user?.pending_payment_data?.[0]?.product?.name } order` : 'orders' } but your payment{ !isOnePenndingPayment ? 's' : '' } was declined{isOnePenndingPayment ? ':' : ''}</p>
                  {
                     isOnePenndingPayment ?
                        <p>{user?.pending_payment_data?.[0]?.payment?.gateway_response?.failure_reason}</p>
                        :
                        null
                  }
                  <p>Please try the payment{ !isOnePenndingPayment ? 's' : '' } again when the issue has been resolved.</p>
               </div>
               {
                  isOnePenndingPayment &&
                  <Button
                     text='Contact support'
                     classNames='mt-8'
                     textColor='secondary'
                     textClassName='dark:text-secondary-dark'
                     backgroundColor='transparent'
                     textSize='small'
                     onClick={ () =>  {
                        if(window?.Intercom) {
                           window.Intercom('show');
                        }
                     } }
                  />
               }
            </ConfirmModal>
         }
         {
            isOpenSendModal && modalType === 'store' && pageType === 'all' && (
               <Suspense fallback={ <></> }>
                  <SendModal
                     id={ user?.pending_payment_data?.[0]?.payload?.id }
                     usdTerms={ +user?.pending_payment_data?.[0]?.payload?.total_price }
                     type='store'
                     onCloseSendModal={ async (bool) => {
                        await setSendModalState({ isOpenSendModal: bool, isSend: false, isNotEnoughtBalance: false, modalKey: 'tip', pageType: '' })
                        let isOpen = true
                        if(Router.route('MY_ORDERS').match(locationPath) || Router.route('ORDER_DETAILS').match(locationPath)) {
                           isOpen = false
                        }
                        await openClosePenndingPaymentModal(isOpen)
                     } }
                     mediaName={ user?.pending_payment_data?.[0]?.product?.name }
                     onCloseSuccessModal={ async () => {
                        setSendModalState({ isOpenSendModal: false, isSend: false, isNotEnoughtBalance: false, modalKey: 'tip', pageType: '' })
                     } }
                     actionAfterPayment={ (data) => this.actionAfterPayment(data) }
                  />
               </Suspense>
            )
         }
         { header }
         {
            shareModal?.isOpen && (
               <Suspense fallback={ <></> }>
                  <ShareModal
                     isAdmin={ false }
                     onCloseModal={ () => setShareModal({}) }
                     siteLink={ siteInfo?.subdomain }
                     siteName={ siteInfo.site_name }
                     shareDescription={ '' }
                     sitePrefix={ siteInfo?.site_name }
                     savedQrStyles={ {
                        isBgTransparent: true,
                        qrBackground: siteInfo?.is_dark_bg ? '#2C2C2C' : '#F9FAFB',
                        qrColor: siteInfo?.is_dark_bg ? '#FFFFFF' : '#041527',
                     } }
                     updateQrStyles={ () => {} }
                     screenWidth={ screenWidth }
                     textClass='!text-sm text-action'
                     onClickRegister={ () => {
                        window.location.href = `${ getSiteLink() }?ref=rf${ siteInfo?.referal_code }`
                     } }
                     additionalInfo={ shareModal?.additionalInfo }
                     appIcon={ siteInfo?.favicon_80 }
                     componentDidMountCallback={ (isOpened) => {
                        if(isOpened){
                           QueryParams.setQueryParam('share', true)
                        } else {
                           QueryParams.removeQueryParam('share')
                        }
                     } }
                     ownerTwitterNickname={ siteInfo?.owner_twitter_nickname || '' }
                     siteLongName={ siteInfo.site_long_name || '' }
                     adminScreenName={ siteInfo?.admin_screen_name || '' }
                  />
               </Suspense>
            )
         }
         {
            !!boomfiModal?.isOpen &&
            <BoomfiPaymentModal
               data={ boomfiModal?.data }
               isMobile={ screenWidth < 900 }
            />
         }
      </>;
   }
}

const mapStateToProps = (state) => {
   return {
      locationPath: currentLocationPathSelector(state),
      user: authUserSelector(state),
      showNavigationList: showNavigationListSelector(state),
      unreadChatMessageCount: unreadMessageCount(state),
      screenWidth: screenWidthSelector(state),
      siteInfo: siteInfoSelector(state),
      initedChat: initedSelector(state),
      chatPanel: chatPanelSelector(state),
      publicMessages: publicMessagesSelector(state),
      privateMessages: privateMessagesSelector(state),
      groupChat: groupChatSelector(state),
      privateChat: privateChatSelector(state),
      tipModalData: tipModalDataSelector(state),
      isCheckLimitFetching: isCheckLimitFetchingSelector(state),
      onlineStream: onlineStreamSelector(state),
      hiddeChatIcon: hiddeChatIconSelector(state),
      chatSettings: chatSettingsSelector(state),
      promotionNotification: promotionNotificationSelector(state),
      unseenNotificationsCount: unseenNotificationsCountSelector(state),
      notificationsPanel: notificationsPanelSelector(state),
      isOpenPenndingPaymentModal: isOpenPenndingPaymentModalSelector(state),
      isOpenSendModal: isOpenSendModalSelector(state),
      modalType: modalTypeSelector(state),
      pageType: pageTypeSelector(state),
      pollData: pollDataSelector(state),
      isAgeVerificationRequired: isAgeVerificationRequiredSelector(state),
      shareModal: shareModalSelector(state),
      activeOrderRequest: activeOrderRequestSelector(state),
      boomfiModal: boomfiModalSelector(state),
      isGlobalLoading: isGlobalLoadingSelector(state),
      siteHeader: siteHeaderSelector(state),
   }
}

const mapDispatchToProps = (dispatch) => {
   return {
      goTo: (location, search) => {
         if(search) {
            dispatch(push({
               pathname: location,
               search,
            }))
         } else {
            dispatch(push(location))
         }
      },
      collapseMenu: () => {
         dispatch(collapseMenu())
      },
      onClickChat: (bool, inited) => {
         // if(!inited) {
         //    dispatch(chatInitOperation())
         // }
         dispatch(onClickChat(bool))
      },
      setChatPanel: (data) => {
         dispatch(setChatPanelAction(data))
      },
      chatInitOperation: (inited) => {
         dispatch(chatInitOperation(inited))
      },
      fetchMessages: (id, data, inited, callback) => {
         dispatch(fetchMessagesOperation(id, data, inited, callback))
      },
      getWalletBalance: (data) => { dispatch(getWalletBalanceOperation(data)) },
      setTipModalState: (data) => { dispatch(setTipModalState(data)) },
      setSendModalState: (data) => { dispatch(setSendModalState(data)) },
      setActiveTab: (data) => { dispatch(setActiveTab(data)) },
      setNotificationsPanel: (data) => { dispatch(setNotificationsPanelAction(data)) },
      fetchLiveStreamMessages: () =>  dispatch(fetchLiveStreamMessagesOperation()),
      closePromotionNotification: () => dispatch(closePromotionNotification()),
      markAllAsSeenNotifications: () =>  dispatch(markAllAsSeenNotificationsOperations()),
      fetchNotifications: () =>  dispatch(fetchNotificationsOperation()),
      openClosePenndingPaymentModal: (bool) =>  dispatch(openClosePenndingPaymentModal(bool)),
      openPollModal: () => dispatch(openActivePollModalOperation()),
      setShowNSFWModal: (bool) => dispatch(setShowNSFWModalAction(bool)),
      setShareModal: (data) => dispatch(setShareModalAction(data)),
      updateSiteInfo: (data) => dispatch(updateSiteInfoAction(data)),
      fetchOrderRequestById: (id, callback) => dispatch(fetchOrderRequestById(id, callback)),
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(PageHeaderContainer);
